export const SESSION_STATE = {
  INIT: 'INIT',
  START: 'START',
  ACTIVE: 'ACTIVE',
  END: 'END',
};

export const REPORT_GENERATION_STATUS = {
  CTK: 'CTK',
  RGP: 'RGP',
};

// Adaptive test (ADP) primary CTA labels
export const ADP_PRIMARY_CTA = {
  NEXT: 'PROCEED TO NEXT',
  NEXT_SECTION: 'PROCEED TO NEXT SECTION',
  SUBMIT: 'SUBMIT ASSESSMENT',
};
